/**
 * 自 mtr-struct tree 解析主分類 code（產品物料鎖 A）。
 *
 * @param {object[]} treeRows
 * @param {string} [code='A']
 * @returns {string|null}
 */
export function resolveStructMainIdByCode(treeRows = [], code = 'A') {
  const match = (treeRows ?? []).find(
    (main) => String(main?.code ?? '').toUpperCase() === String(code).toUpperCase(),
  );
  return match?.id ?? null;
}
